
export const PRE_CANDIDATE_NATIONALITY_LIST_MASTER = [
    "VN", // Fix, not nationality
    "Expat", // Fix, not nationality
    "Người VN đang ở NN", // Fix, not nationality
    "Expat đang ở VN", // Fix, not nationality
]

export const PRE_EMPLOYER_NATIONALITY_LIST_MASTER = [
    "VN", // Fix, not nationality
    "FDI", // Fix, not nationality
]

export const NATIONALITY_LIST_MASTER = [
    "Afghan",
    "Armenian",
    "Azerbaijani",
    "Bahraini",
    "Bangladeshi",
    "Bhutanese",
    "Bruneian",
    "Cambodian",
    "Chinese",
    "Georgian",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Israeli",
    "Japanese",
    "Jordanian",
    "Kazakh",
    "Kuwaiti",
    "Laotian",
    "Lebanese",
    "Malaysian",
    "Maldivian",
    "Burmese",
    "Nepalese",
    "Korean",
    "Omani",
    "Pakistani",
    "Palestinian",
    "Filipino",
    "Qatari",
    "Saudi Arabian/ Saudi",
    "Singaporean",
    "Sri Lankan",
    "Taiwanese",
    "Turkish",
    "Uzbek",
    // "Vietnamese",
    "Yemeni",
    "Albanian",
    "Andorran",
    "Austrian",
    "Belarusian",
    "Belgian",
    "Bulgarian",
    "Croatia",
    "Cypriot",
    "Czech",
    "Danish",
    "English",
    "British",
    "Estonian",
    "Finnish",
    "French",
    "German",
    "Greek",
    "Dutch",
    "Hungarian",
    "Icelandic",
    "Irish",
    "Italian",
    "Latvian",
    "Luxembourger",
    "Monacan",
    "Norwegian",
    "Polish",
    "Portuguese",
    "Romanian",
    "Russian",
    "Scottish",
    "Serbian",
    "Serb",
    "Slovak",
    "Slovene",
    "Slovenian",
    "Spanish",
    "Swedish",
    "Swiss",
    "Ukrainian",
    "UK",
    "British",
    "Welsh",
    "American",
    "Argentinian",
    "Bolivian",
    "Brazilian",
    "Canadian",
    "Chilean",
    "Colombian",
    "Costa Rican",
    "Cuban",
    "Dominican",
    "Ecuadorian",
    "Salvadoran",
    "Guatemalan",
    "Guyanese",
    "Haitian",
    "Honduran",
    "Jamaican",
    "Mexican",
    "Panamanian",
    "Paraguayan",
    "Peruvian",
    "Ugandan",
    "Venezuelan",
    "Algerian",
    "Angolan",
    "Cameroonian",
    "Congolese",
    "Egyptian",
    "Ethiopian",
    "Gambian",
    "Ghanaian",
    "Kenyan",
    "Libyan",
    "Malagasy/ Madagascan",
    "Moroccan",
    "Mozambican",
    "Nigerian",
    "Somali",
    "South African",
    "Sudanese",
    "Tanzanian",
    "Tunisian",
    "Zambian",
    "Zimbabwean",
    "Australian",
    "New Zealand",
    "Papua New Guinean",
    "Guinean",
]

export const CANDIDATE_NATIONALITIES = [...PRE_CANDIDATE_NATIONALITY_LIST_MASTER, ...NATIONALITY_LIST_MASTER].map(item => {
    return {value: item.toLowerCase(), label: item}
})

// Values is options (value, label)
export const checkNationalOptionsHaveExpatAndVN = (values) => {
    const arr = values.map(item => {
        return item.value
    })

    const hasVN = arr.some(item => item === "vn" || item === 'người vn đang ở nn');
    const hasOtherThanVN = arr.some(item => item !== "vn" && item !== 'người vn đang ở nn');

    return (hasVN && hasOtherThanVN);

}

export const EMPLOYER_NATIONALITIES = [...PRE_EMPLOYER_NATIONALITY_LIST_MASTER, ...NATIONALITY_LIST_MASTER].map(item => {
    return {value: item.toLowerCase(), label: item}
})

export const COUNTRY_LIST_MASTER = [
    "Oversea", // Fix, not country
    "Afghanistan",
    "Armenia",
    "Azerbaijan",
    "Bahrain",
    "Bangladesh",
    "Bhutan",
    "Brunei",
    "Cambodia",
    "China",
    "Georgia",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Israel",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kuwait",
    "Laos",
    "Lebanon",
    "Malaysia",
    "Maldives",
    "Myanmar",
    "Nepal",
    "Korea",
    "Oman",
    "Pakistan",
    "Palestine",
    "Philippines",
    "Qatar",
    "Saudi Arabia",
    "Singapore",
    "Sri Lanka",
    "Taiwan",
    "Thailand",
    "Turkey",
    "Uzbekistan",
    "Vietnam",
    "Yemen",
    "Albania",
    "Andorra",
    "Austria",
    "Belarus ",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "England",
    "Britain",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Holland",
    "Netherlands",
    "Hungary",
    "Iceland",
    "Ireland",
    "Italy",
    "Latvia",
    "Luxembourg",
    "Monaco",
    "Norway",
    "Poland",
    "Portugal",
    "Romania",
    "Russia",
    "Scotland",
    "Serbia",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden",
    "Switzerland",
    "Ukraine",
    "United Kingdom",
    "Wales",
    "America",
    "United States",
    "USA",
    "Argentina",
    "Bolivia",
    "Brazil",
    "Canada",
    "Chile",
    "Colombia",
    "Costa Rica",
    "Cuba",
    "Dominican Republic",
    "Ecuador",
    "El Salvador",
    "Guatemala",
    "Guyana",
    "Haiti",
    "Honduras",
    "Jamaica",
    "Mexico",
    "Panama",
    "Paraguay",
    "Peru",
    "Uganda",
    "Venezuela",
    "Algeria",
    "Angola",
    "Cameroon",
    "Congo",
    "Egypt",
    "Ethiopia",
    "Gambia",
    "Ghana",
    "Kenya",
    "Libya",
    "Madagascar",
    "Morocco",
    "Mozambique",
    "Nigeria",
    "Somalia",
    "South Africa",
    "Sudan",
    "Tanzania",
    "Tunisia",
    "Zambia",
    "Zimbabwe",
    "Australia",
    "New Zealand",
    "Papua New Guinea",
]

export const COUNTRIES = COUNTRY_LIST_MASTER.map(item => {
    return {value: item.toLowerCase(), label: item}
})
